import { Sparkle } from "@phosphor-icons/react";

/**
 * Subtle sitewide notice: Pro is free during launch.
 * Show only when API plan catalog reports launch_free=true.
 */
export default function LaunchFreeBanner({ visible }) {
  if (!visible) return null;
  return (
    <div className="w-full bg-[#0a0a0a] text-white text-xs sm:text-sm font-semibold tracking-wide px-4 py-2 text-center" data-testid="launch-free-banner">
      <span className="inline-flex items-center gap-2">
        <Sparkle size={12} weight="fill" color="#D97706" />
        Pro is free for everyone right now - every signup gets unlimited tracking. No card needed.
      </span>
    </div>
  );
}
